;(function () {
  const ROOT_SELECTOR = '.hero-carousel-cottolio';
  const SLIDER_SELECTOR = '.hero-carousel-cottolio__slider.swiper';

  const destroySwiper = (sliderEl) => {
    const instance = sliderEl?.swiper;
    if (!instance) return;

    try {
      instance.destroy(true, true);
    } catch (error) {
      try {
        instance.destroy(true, false);
      } catch (nestedError) {
        /* noop */
      }
    }
  };

  const init = (root) => {
    if (typeof window.Swiper === 'undefined') return null;

    const sliderEl = root.querySelector(SLIDER_SELECTOR);
    if (!sliderEl) return null;

    if (sliderEl.classList.contains('swiper-initialized')) {
      destroySwiper(sliderEl);
    }

    const slides = sliderEl.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;
    if (slideCount < 2) return null;

    const paginationEl = root.querySelector('.hero-carousel-cottolio__pagination');

    const autoplayEnabled = root.dataset.heroCarouselAutoplay === 'true';
    const loopEnabled = root.dataset.heroCarouselLoop === 'true';
    const autoplayDelay = parseInt(root.dataset.heroCarouselDelay, 10) || 5000;
    const useLoop = loopEnabled && slideCount >= 2;

    const config = {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 1500,
      loop: useLoop,
      loopAdditionalSlides: useLoop ? 1 : 0,
      watchOverflow: true,
      autoplay: autoplayEnabled
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
    };

    if (paginationEl) {
      config.pagination = {
        el: paginationEl,
        type: 'bullets',
        clickable: true,
      };
    }

    const swiper = new window.Swiper(sliderEl, config);

    if (autoplayEnabled && swiper.autoplay) {
      swiper.autoplay.start();
    }

    return swiper;
  };

  const initAll = (container = document) => {
    container.querySelectorAll(ROOT_SELECTOR).forEach((root) => init(root));
  };

  const initSection = (section) => {
    const root =
      section.matches?.(ROOT_SELECTOR)
        ? section
        : section.querySelector?.(ROOT_SELECTOR);

    if (!root) return;
    init(root);
  };

  const destroySection = (section) => {
    const root =
      section.matches?.(ROOT_SELECTOR)
        ? section
        : section.querySelector?.(ROOT_SELECTOR);

    if (!root) return;
    const sliderEl = root.querySelector(SLIDER_SELECTOR);
    if (sliderEl) destroySwiper(sliderEl);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSection(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroySection(event.target);
  });
})();
